import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/auth.css';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/reset-password', { token, password });
      if (data?.token) localStorage.setItem('adeeb-token', data.token);
      if (data?.user) localStorage.setItem('adeeb-user', JSON.stringify(data.user));
      window.dispatchEvent(new Event('adeeb-auth-change'));
      navigate('/');
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <Link to="/" className="floating-back-btn">&#8592; Library</Link>

      <div className="auth-bg-ornament" aria-hidden="true">&#10040; &#10040; &#10040;</div>

      <div className="auth-card">
        <Link to="/" className="auth-logo"><img className="auth-brand-image" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" /></Link>
        <p className="auth-tagline">Choose a new password</p>

        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <label className="auth-field">
            <span>New password</span>
            <div className="auth-password">
              <input
                type={showPw ? 'text' : 'password'}
                name="password"
                autoComplete="new-password"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => { setPassword(e.target.value); if (error) setError(''); }}
                required
              />
              <button
                type="button"
                className="auth-show-pw"
                onClick={() => setShowPw((v) => !v)}
                aria-label={showPw ? 'Hide password' : 'Show password'}
              >
                {showPw ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          <label className="auth-field">
            <span>Confirm password</span>
            <input
              type={showPw ? 'text' : 'password'}
              name="confirm"
              autoComplete="new-password"
              placeholder="Repeat password"
              value={confirm}
              onChange={(e) => { setConfirm(e.target.value); if (error) setError(''); }}
              required
            />
          </label>

          {error && <div className="auth-error" role="alert">{error}</div>}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Saving…' : 'Reset password'}
          </button>

          <p className="auth-switch">
            <Link to="/login" className="auth-link auth-link-btn">Back to sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
